const STATUS = {
  approved: 'approved',
  denied: 'denied',
};

const ES_STATUS = {
  approved: 'opted-in',
  denied: 'opted-out',
  pending: 'not-opted-in',
};

const STATUS_ICON = {
  approved: 'check_circle_outline',
  denied: 'highlight_off',
  pending: 'help_outline',
};

const STATUS_COLOR = {
  approved: 'var(--v-success-base)',
  denied: 'var(--v-error-base)',
  pending: 'var(--v-warning-base)',
  simple: 'black',
};

const BUTTON_STYLE = {
  approved: {
    'background-color': STATUS_COLOR.approved,
    color: 'white',
  },
  denied: {
    'background-color': STATUS_COLOR.denied,
    color: 'white',
  },
  pending: {
    'background-color': STATUS_COLOR.pending,
    color: 'white',
  },
};

const BUTTON_ICON = {
  approved: 'done',
  denied: 'close',
  pending: 'question_mark',
};

const BUTTON_TOOLTIP = {
  approved: 'This contact has Opted In to receive SMS messages.',
  denied: 'This contact has Opted Out of receiving SMS messages.',
  pending: 'This contact has Not Opted In yet to receive SMS messages.',
};

const STATUS_CARD = {
  approved: {
    name: 'status',
    value: 'Opted In',
    data_type: 'text',
    id: 'status',
    icon: STATUS_ICON.approved,
    style: { color: STATUS_COLOR.approved },
  },
  denied: {
    name: 'status',
    value: 'Opted Out',
    data_type: 'text',
    id: 'status',
    icon: STATUS_ICON.denied,
    style: { color: STATUS_COLOR.denied },
  },
  pending: {
    name: 'status',
    value: 'Not Opted In',
    data_type: 'text',
    id: 'status',
    icon: STATUS_ICON.pending,
    style: { color: STATUS_COLOR.pending },
  },
};

export {
  STATUS,
  ES_STATUS,
  BUTTON_STYLE,
  BUTTON_ICON,
  BUTTON_TOOLTIP,
  STATUS_CARD,
  STATUS_ICON,
  STATUS_COLOR,
};
